import { createSelector } from 'reselect'
import { SettingsRootState } from '../root.reducer'

export const getPrefersDarkMode = createSelector(
  (state: SettingsRootState) => state.settingsStore.prefersDarkMode,
  (state) => state,
)
export const getTheme = createSelector(
  (state: SettingsRootState) => state.settingsStore.theme,
  (state) => state,
)
export const getMessage = createSelector(
  (state: SettingsRootState) => state.settingsStore.message,
  (state) => state,
)
export const getFeedback = createSelector(
  (state: SettingsRootState) => state.settingsStore.feedback,
  (state) => state,
)
